export const originalAmountFormatter = (amount: number, originalAmount?: number) => {
  if (originalAmount && amount !== originalAmount) {
    return `${amount} (${originalAmount})`;
  }

  return amount.toString();
};

// Capitalises a string.
// @param s: string to capitalise
// @param delimiter: optional separator between words to capitalise (defaults to ' ')
// @param joinDelimter: optional separator to use when recombining. If left blank, will default to delimiter; if that is undefined, will use ' '
export const capitalise = (s: string, delimiter?: string, joinDelimiter?: string) => {
  return s
    .split(delimiter || ' ')
    .map(p => p.slice(0, 1).toUpperCase().concat(p.slice(1)))
    .join(joinDelimiter || delimiter || ' ');
};
